import createVueApp from '@/common/createApp'

Styxie.Initializers.SuspendedOrganization = {
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/suspended_organization/show/index.vue')
    createVueApp(ShowPage, { props, layout: null })
  }
}
